import css from "./index.module.less";
import React from "react";

interface Props {
  icon: string;
  title: string;
  desc: string;
  url: string;
  onClick?: (e) => void;
  invert?: boolean;
}

export const DownloadButton = (props: Props) => {
  const { icon, title, desc, url, invert = false } = props;

  return (
    <a href={url} target={"_blank"} onClick={(e) => props?.onClick(e)}>
      <div className={css.container}>
        <img
          src={icon}
          className={css.icon}
          style={invert ? { filter: "invert(1)" } : {}}
        />
        <div className={css.rightContainer}>
          <span>{title}</span>
          <span>{desc}</span>
        </div>
      </div>
    </a>
  );
};
